import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import StudyMode from './components/StudyMode';
import TestMode from './components/TestMode';
import GroupView from './components/GroupView';
import StudyCalendar from './components/StudyCalendar';
import SyncNotifications from './components/SyncNotifications';
import Login from './components/Login';
import Footer from './components/Footer';
import { isLoggedIn } from './auth';

function App() {
    const [loggedIn, setLoggedIn] = useState(isLoggedIn());
    return (
        <div className="app-shell">
            {loggedIn ? (
                <Router basename="/split">
                    <SyncNotifications />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/study/:groupId" element={<StudyMode />} />
                        <Route path="/test/:groupId" element={<TestMode />} />
                        <Route path="/group/:groupId" element={<GroupView />} />
                        <Route path="/calendar" element={<StudyCalendar />} />
                    </Routes>
                </Router>
            ) : (
                // 未登录：只显示登录页，应用其余部分完全不加载
                <Login onLogin={() => setLoggedIn(true)} />
            )}
            <Footer />
        </div>
    );
}

export default App;
